<div class="modal-body">
  <div class="modal-header-wrapper">
    <h2 class="title-text">Retirer {{ targetName() }} d'un groupe</h2>
    <p class="subtitle-text">Sélectionnez le groupe duquel vous souhaitez retirer {{ targetName() }}.</p>
    <p class="subtitle-text" *ngIf="multiTarget()">Liste des groupes que tous les patients ont en commun...</p>
  </div>
  <div id="modal-content-wrapper">
    <div *ngIf="!error && !isLoading && filterGroups() && filterGroups().length > 0; else innerLoading" id="group-list-wrapper">
      <msd-patient-group-cell *ngFor="let group of filterGroups()"
                              (click)="selectGroup(group.id.toString())"
                              [class.active]="group.id.toString() === selectedGroupId"
                              [class.already-added]="!alreadyGrouped(group.id.toString())"
                              [name]="group.name"
                              [patientCount]="group.activatedPatientCount"></msd-patient-group-cell>
    </div>

    <ng-template #innerLoading>
      <ngx-inner-loading class="flex-center" [empty]="filterGroups()?.length === 0" [error]="!!error" [loading]="isLoading"
                         (retry)="loadPatientGroups()" [loadingDescription]="'Chargement...'" [emptyDescription]="'Aucun groupe'"
                         [errorDescription]="error" [retryButtonText]="'Réessayer'">
      </ngx-inner-loading>
    </ng-template>
  </div>
  <div class="modal-footer">
    <div class="right-wrapper">
      <button id="cancel-button" (click)="hideModal()" type="button"
              class="btn btn-outline-primary btn-outline text-only">
        Annuler
      </button>

      <button id="validate-button" [disabled]="isLoading || !selectedGroupId || isRemoving" type="submit"
              (click)="removePatientFromGroup()" type="button" class="btn btn-primary btn-gradient">
        <ng-container *ngIf="isLoading || isRemoving; else validateButton">
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </ng-container>
        <ng-template #validateButton>
          Retirer
          <i i-bs name="person-dash" width="15" height="15"></i>
        </ng-template>
      </button>
    </div>
  </div>
</div>
